import { ContentTypes } from '@/client/services/api/graphql/gql/graphql';

export const setSubmissionContentType = (contentType: string | undefined) => {
  // * Content type from the search data is different than the ContentTypes enum

  // * First check if contentType matches a ContentTypes enum value
  if (Object.values(ContentTypes).includes(contentType as ContentTypes)) {
    return contentType as ContentTypes;
  }

  // * Then check lowercase versions
  if (contentType === 'article') return ContentTypes.Article;
  if (contentType === 'video') return ContentTypes.Video;
  if (contentType === 'file') return ContentTypes.File;
  if (contentType === 'media') return ContentTypes.Media;
  if (contentType === 'quiz') return ContentTypes.Quiz;
  if (contentType === 'scorm') return ContentTypes.Scorm;
  if (contentType === 'presentation') return ContentTypes.Presentation;
  if (contentType === 'poll') return ContentTypes.Poll;
  if (contentType === 'assessment') return ContentTypes.Assessment;
  if (contentType === 'journey') return ContentTypes.Journey;
  if (contentType === 'workshop') return ContentTypes.Workshop;
  if (contentType === 'multi_session_workshop') return ContentTypes.MultiSessionWorkshop;
  if (contentType === 'imported_content') return ContentTypes.ImportedContent;
  if (contentType === 'track') return ContentTypes.Track;
};
